import { createContext } from 'react';

import type { SankeyCustomTooltipConfig } from '../types/sankey-internal.js';

export const SankeyCustomTooltipContext = createContext<
  SankeyCustomTooltipConfig | undefined
>(undefined);
